import type { GetPostFeedMetadataPageRequest } from '@wix/ambassador-blog-frontend-adapter-public-v2-post-feed-page/types';
import { SET_FEED_METADATA_PARAMS } from '../../actions/fetch-feed-metadata';

interface FeedMetadataParamsAction {
  type: string;
  payload?: GetPostFeedMetadataPageRequest;
}

const feedMetadataParams = (
  state: GetPostFeedMetadataPageRequest | null = null,
  { type, payload }: FeedMetadataParamsAction = {} as FeedMetadataParamsAction,
): GetPostFeedMetadataPageRequest | null => {
  switch (type) {
    case SET_FEED_METADATA_PARAMS:
      return payload || null;
    default:
      return state;
  }
};

export default feedMetadataParams;
